import {
  IngredientsSalesTableByLanguagePayloadModel,
  InventoryPdfPayloadModel,
  DishesPdfPayloadModel,
  MenuItemsSalesExcelPayloadModel,
  IngredientsSalesExcelPayloadModel,
  MenuItemsSalesTableByLanguagePayloadModel,
  MenuItemsSalesTableByLanguageResponseModel,
  SalesReportResponseModel
} from './SalesReportsAPI.model'
import { HTTPInstanceFastApiWithPrefix } from '@/lib/http/http-instance-fastapi-with-prefix'

class SalesReportsAPI {
  static getDishesAndToppingsSalesReport = (
    _currentLanguage: string
  ): Promise<SalesReportResponseModel> =>
    HTTPInstanceFastApiWithPrefix.get(`/dishes-sales-table-by-language`).then(
      response => response.data
    )

  static getIngredientsSalesReport = (
    _currentLanguage: string
  ): Promise<SalesReportResponseModel> =>
    HTTPInstanceFastApiWithPrefix.get(
      `/ingredients-sales-table-by-language`
    ).then(response => response.data)

  static getMenuItemsSalesTableByLanguage = (
    params: MenuItemsSalesTableByLanguagePayloadModel
  ): Promise<MenuItemsSalesTableByLanguageResponseModel> =>
    HTTPInstanceFastApiWithPrefix.get('/menu-items-sales-table-by-language', {
      params
    }).then(response => response.data)

  static getIngredientsSalesTableByLanguage = (
    params: IngredientsSalesTableByLanguagePayloadModel
  ): Promise<MenuItemsSalesTableByLanguageResponseModel> =>
    HTTPInstanceFastApiWithPrefix.get('/ingredients-sales-table-by-language', {
      params
    }).then(response => response.data)

  static getInventoryPdf = (params: InventoryPdfPayloadModel): Promise<Blob> =>
    HTTPInstanceFastApiWithPrefix.get('/sales/inventory-pdf', {
      params,
      responseType: 'blob'
    }).then(response => response.data)

  static getDishesSalesPdf = (params: DishesPdfPayloadModel): Promise<Blob> =>
    HTTPInstanceFastApiWithPrefix.get('/sales/dishes-pdf', {
      params,
      responseType: 'blob'
    }).then(response => response.data)

  static getMenuItemsSalesExcel = (
    params: MenuItemsSalesExcelPayloadModel
  ): Promise<Blob> =>
    HTTPInstanceFastApiWithPrefix.get('/sales/menu-items-by-language/excel', {
      params,
      responseType: 'blob'
    }).then(response => response.data)

  static getIngredientsSalesExcel = (
    params: IngredientsSalesExcelPayloadModel
  ): Promise<Blob> =>
    HTTPInstanceFastApiWithPrefix.get('/sales/ingredients-by-language/excel', {
      params,
      responseType: 'blob'
    }).then(response => response.data)
}
export default SalesReportsAPI
